import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';

export const EPSG3857 = 'EPSG:3857';
export const EPSG4326 = 'EPSG:4326';

export const ProjectionType = {
    Linear: 'linear',
    LCC: 'lcc',
};

export const generateDefinition = params => (
    [...Object.keys(params).map(key => `+${key}=${params[key]}`), '+no_defs'].join(' ')
);

export const getLCCProjectionName = id => `TM:${id}`;

const registerProjection = region => {
    const {id, projection, children} = region;

    if (projection.type === ProjectionType.LCC) {
        const name = getLCCProjectionName(id);
        const {type, extent, ...params} = projection;
        const definition = generateDefinition({...params, proj: type});

        proj4.defs(name, definition);
    }

    return registerProjections(children);
};

const registerProjections = regions => {
    regions.forEach(region => registerProjection(region));
};

export default regions => {
    registerProjections(regions);
    register(proj4);
};
